import { memo, useState, JSX } from 'react'
import useBackdropClick from 'hooks/useBackdropClick'

import DropdownButton from './DropdownButton'
import * as Styled from './styled'
import { DropdownOverlay } from './DropdownOverlay'
import { getDropdownContentPosition } from './utils'
import { useEventListener } from 'hooks'

interface IProps {
  headerContent: JSX.Element
  mainContent: JSX.Element | null
  isOpen: boolean
  toggleDropdown: () => void
  closeDropdown: () => void
  className?: string
  overlayClassName?: string
  scrollableParentRef?: React.RefObject<HTMLDivElement | null>
  hasTogglerArrow?: boolean
  forceBottom?: boolean
  disabled?: boolean
}

export const Dropdown: React.FC<IProps> = memo(props => {
  const {
    headerContent,
    mainContent,
    isOpen,
    toggleDropdown,
    closeDropdown,
    className,
    overlayClassName,
    scrollableParentRef,
    hasTogglerArrow = true,
    forceBottom,
    disabled = false
  } = props

  const [dropdownOverlayNode, setDropdownOverlayNode] =
    useState<HTMLDivElement | null>(null)

  const backdropRef = useBackdropClick<HTMLDivElement>(() => {
    if (isOpen) {
      closeDropdown()
    }
  }, ['.dropdown-overlay-wrapper'])

  const positionOptions = getDropdownContentPosition({
    dropdownWrapperRef: backdropRef,
    dropdownOverlayNode,
    forceBottom
  })

  useEventListener('scroll', closeDropdown, scrollableParentRef?.current)

  return (
    <Styled.DropdownWrapper ref={backdropRef} className={className}>
      <DropdownButton
        toggleDropdown={toggleDropdown}
        content={headerContent}
        isOpen={isOpen}
        hasTogglerArrow={hasTogglerArrow}
        disabled={disabled}
      />
      {mainContent && !disabled && (
        <DropdownOverlay
          isOpen={isOpen}
          content={mainContent}
          setRef={setDropdownOverlayNode}
          positionOptions={positionOptions}
          overlayClassName={`dropdown-overlay-wrapper ${overlayClassName || ''}`}
        />
      )}
    </Styled.DropdownWrapper>
  )
})

Dropdown.displayName = 'Dropdown'

export default Dropdown
